import * as React from 'react';
import { Layout, Menu, Divider, Icon } from 'antd';
import { withRouter, RouteComponentProps, Link } from 'react-router-dom';
import { ROUTE_NAMES } from '@bakbak/common';
import { SearchBarComponent } from './SearchBarComponent';
import { THEME_COLOR } from '../../../constants';

const { Header } = Layout;

export class HeaderAuthC extends React.PureComponent<RouteComponentProps<{}>> {
  renderSearch = () => (
    <React.Fragment>
      <Link to={ROUTE_NAMES.HOME} style={{ marginRight: 20, color: THEME_COLOR, marginTop: 5 }}>
        {/* <img src={require('../../../images/logo.png')} alt="logo" height="40" width="40" /> */}
        <Icon type="home" style={{ fontSize: '28px', }} />
      </Link>
      <SearchBarComponent />
    </React.Fragment>
  )
  render() {
    return (
      <React.Fragment>
        <Header
          style={{ background: '#fff', display: 'flex', flexDirection: 'row', height: 'auto', borderBottom: 0 }}
        >
          {this.renderSearch()}
          <div style={{ marginLeft: 'auto', display: 'flex', flexDirection: "row" }}>
            <Menu mode="horizontal" style={{ borderColor: "white", lineHeight: 5 }}>
              <Menu.Item key="0" >
                <Link to={ROUTE_NAMES.LOGIN}>Login</Link>
              </Menu.Item>
              <Menu.Item key="1">
                <Link to={ROUTE_NAMES.REGISTER}>Register</Link>
              </Menu.Item>
            </Menu>
          </div>
        </Header>
        <Divider style={{ margin: 0, marginBottom: 5, marginTop: 5 }} />
      </React.Fragment>
    );
  }
}

export const HeaderAuthView = withRouter(HeaderAuthC);



// WEBPACK FOOTER //
// ./src/modules/layout/header/HeaderAuthView.tsx